import { useMutation, useQueryClient } from '@tanstack/react-query';

import { completePolicy } from '@/policy/api/CompletePolicy';
import { FrontendPolicyValidationResult } from '@/policy/contexts/ValidationContext';

interface CompletePolicyParams {
  uuid: string;
  validations: FrontendPolicyValidationResult;
}

interface UseCompletePolicyOptions {
  onSuccess: () => void;
  onError?: (error: unknown) => void;
}

export const useCompletePolicy = ({
  onSuccess,
  onError,
}: UseCompletePolicyOptions) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: async ({ uuid, validations }: CompletePolicyParams) => {
      const result = await completePolicy(uuid, validations);
      return result;
    },
    onSuccess: (_, { uuid }) => {
      onSuccess();
      queryClient.invalidateQueries({ queryKey: ['policy', uuid] });
      queryClient.invalidateQueries({ queryKey: ['policies'] });
    },
    onError: onError ? (error) => onError(error) : undefined,
  });

  return {
    completePolicy: mutate,
    isCompleting: isPending,
  };
};
